import React, { useEffect, useState } from "react";

import FooterImg from "./../assets/AyurvedaAssets/images/footer-img.jpg";

export default function AYFooter(props) {
  const [showButtons, setShowButtons] = useState(false);
  const [Appointment, setAppointment] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [serviceIntrested, setServiceIntrested] = useState("");
  const [message, setMessage] = useState("");

  const [waLink, setWaLink] = useState(null);
  useEffect(() => {
    const offSet = 50;

    if (props.production == false) {
      setAppointment("http://localhost:8001");
    } else if (props.production == true) {
      setAppointment("https://appointment.bharatdhara.com");
    }

    const handleScroll = () => {
      let scrollFromTop = window.scrollY;

      if (scrollFromTop > offSet) {
        setShowButtons(true);
      } else if (scrollFromTop === 0) {
        setShowButtons(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // cleanup on unmount
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Toggle Popup
  const toggleChatPopup = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (name && email && serviceIntrested && message) {
      const phone = "917060112355";

      const finalMessage = `Hi, I'm ${name}
                            Email: ${email}
                            Service Interested: ${serviceIntrested}
                            Message: ${message}`;

      // Replace line breaks for WhatsApp Web
      const formattedMessage = encodeURIComponent(finalMessage).replace(
        /%0A/g,
        "%0A"
      );
      const waUrl = `https://api.whatsapp.com/send?phone=${phone}&text=${formattedMessage}`;

      setWaLink(waUrl); // auto-generate
    }
  }, [name, email, serviceIntrested, message]);

  return (
    <footer className="footer widget-footer bg-base-dark text-base-white overflow-hidden clearfix">
      <button
        className={`whatsapp-toggle ${showButtons ? "" : "d-none"}`}
        id="toggleBtn"
        data-aos="fade-up"
        onClick={toggleChatPopup}
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          alt="Chat"
          id="toggleIcon"
        />
      </button>

      <a
        href={Appointment}
        target="_blank"
        className={`btn btn-info book-vacation-now ${
          showButtons ? "" : "d-none"
        }`}
        data-aos="fade-up"
        id="bookVacationNow"
      >
        Book Now <i className="fa-regular fa-calendar-check"></i>
      </a>

      {isOpen == true && (
        <div className="chat-popup" id="chatPopup">
          <div className="chat-header">
            <b>Chat with us now!</b>
            <span onClick={toggleChatPopup}>
              <i className="fa fa-times-circle"></i>
            </span>
          </div>
          <div className="chat-body">
            <input
              type="text"
              id="userName"
              className="form-control"
              placeholder="Your Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <input
              type="text"
              id="userEmailId"
              className="form-control"
              placeholder="Your Email Id"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type="text"
              id="serviceIntrestedIn"
              className="form-control"
              placeholder="Intrested Service"
              value={serviceIntrested}
              onChange={(e) => setServiceIntrested(e.target.value)}
            />
            <textarea
              id="userMessage"
              className="form-control"
              placeholder="Your Message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            ></textarea>
            {waLink && (
              <a
                href={waLink}
                className="send-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                Enquire Now
              </a>
            )}
          </div>
        </div>
      )}

      <div className="second-footer">
        <div className="container">
          <div className="row">
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
              <div className="footer-widget-box prt-pr">
                <h3 className="widget-title-h3">Quick link</h3>
                <div className="footer-menu-links">
                  <ul className="footer-menu-list">
                    <li className="footer-menu-item">
                      <a
                        href="#"
                        onClick={(e) => e.preventDefault()}
                        className="footer-menu-item-link"
                      >
                        About us
                      </a>
                    </li>
                    <li className="footer-menu-item">
                      <a
                        href="#"
                        onClick={(e) => e.preventDefault()}
                        className="footer-menu-item-link"
                      >
                        Experiences
                      </a>
                    </li>
                    <li className="footer-menu-item">
                      <a
                        href="#"
                        onClick={(e) => e.preventDefault()}
                        className="footer-menu-item-link"
                      >
                        Our patients
                      </a>
                    </li>
                    <li className="footer-menu-item">
                      <a
                        href="#"
                        onClick={(e) => e.preventDefault()}
                        className="footer-menu-item-link"
                      >
                        Home care
                      </a>
                    </li>
                    <li className="footer-menu-item">
                      <a
                        href="#"
                        onClick={(e) => e.preventDefault()}
                        className="footer-menu-item-link"
                      >
                        Services
                      </a>
                    </li>
                    <li className="footer-menu-item">
                      <a
                        href="#"
                        onClick={(e) => e.preventDefault()}
                        className="footer-menu-item-link"
                      >
                        Success story
                      </a>
                    </li>
                    <li className="footer-menu-item">
                      <a
                        href="#"
                        onClick={(e) => e.preventDefault()}
                        className="footer-menu-item-link"
                      >
                        Doctors
                      </a>
                    </li>
                  </ul>
                </div>
                {/* Newsletter */}
                <div className="newsletter-form-main clearfix">
                  <h3 className="widget-title-h3">Our newsletter</h3>
                  <div className="widget-form">
                    <form
                      id="subscribe-form"
                      className="newsletter-form"
                      method="post"
                      action="#"
                      data-mailchimp="true"
                    >
                      <div
                        className="mailchimp-inputbox clearfix"
                        id="subscribe-content"
                      >
                        <p>
                          <input
                            type="email"
                            name="email"
                            placeholder="Name*"
                            required
                          />
                        </p>
                        <button className="submit" type="submit">
                          Go
                        </button>
                      </div>
                      <p className="cookies">
                        <input
                          type="checkbox"
                          name="cookies-consent"
                          id="cookies-consent1"
                        />
                        <label htmlFor="cookies-consent1"></label>I agree to all
                        terms and conditions
                      </p>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-2 col-lg-2 col-md-6 col-sm-12">
              <div className="footer-widget-box">
                <div className="footer-img footer-image-sec">
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    <img
                      width="441"
                      height="385"
                      className="footer-offer-img img-fluid w-80 border-rad_10"
                      src={FooterImg}
                      alt="image"
                    />
                  </a>
                </div>
                <div className="footer-img footer-image-sec">
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    <img
                      width="441"
                      height="385"
                      className="footer-offer-img img-fluid w-80 border-rad_10"
                      src={FooterImg}
                      alt="image"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="footer-widget-box prt-pl">
                <h3 className="widget-title-h3">Contact</h3>
                <div className="row">
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    IN: <a href="tel:1234567890">+91-7060112355</a>
                    <br />
                    <a href="tel:1234567890">support@bharatdhara.com</a>
                  </div>
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    B-107 Awas Vikas Colony, Khatauli, District Muzaffar Nagar,
                    UP -251201, India
                  </div>
                </div>
                {/* social-icons */}
                <div className="social-icons">
                  <h3 className="widget-title-h3">Follow on social media</h3>
                  <ul className="footer-social-icons">
                    <li className="footer-social-icons-item">
                      <a
                        href="https://www.facebook.com/bharatdharacares/"
                        target="_blank"
                        className="footer-social-icons-link"
                      >
                        Facebook
                      </a>
                    </li>
                    {/* <li className="footer-social-icons-item">
                      <a
                        href="#"
                        target="_blank"
                        className="footer-social-icons-link"
                      >
                        Dribbble
                      </a>
                    </li> */}
                    <li className="footer-social-icons-item">
                      <a
                        href="https://www.youtube.com/@Bharatdharacares"
                        target="_blank"
                        className="footer-social-icons-link"
                      >
                        YouTube
                      </a>
                    </li>
                    {/* <li className="footer-social-icons-item">
                      <a
                        href="#"
                        target="_blank"
                        className="footer-social-icons-link"
                      >
                        Pinterest
                      </a>
                    </li> */}
                    <li className="footer-social-icons-item">
                      <a
                        href="https://www.instagram.com/bharatdharacares/"
                        target="_blank"
                        className="footer-social-icons-link"
                      >
                        Instagram
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="copyright">
                  <div className="copyright-text">
                    <ul className="footer-nav-menu">
                      <li>
                        <a href="#" onClick={(e) => e.preventDefault()}>
                          {" "}
                          Privacy policy{" "}
                        </a>
                      </li>
                      <li>
                        <a href="#" onClick={(e) => e.preventDefault()}>
                          {" "}
                          Terms and conditions
                        </a>
                      </li>
                      <li>
                        <a href="#" onClick={(e) => e.preventDefault()}>
                          {" "}
                          Help{" "}
                        </a>
                      </li>
                    </ul>
                    <div className="cpy-text">
                      <p>2025 BharatDhara© All rights reserved</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-footer">
        <div className="container-fluid p-0">
          {/* row */}
          <div className="row">
            <div className="col-lg-12">
              <div className="marquee-block overflow-hidden">
                <div className="marquee">
                  <div className="marquee-content">
                    {Array(10).fill(
                      <div className="marquee-text">
                        Like & follow from you. new free to use projects from
                        us.
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* row end */}
        </div>
      </div>
    </footer>
  );
}
